import { type Context, createContext } from 'react';

/** @internal */
type AccordionSectionContextProps = {
  labelId: string;
  triggerId: string;
  contentId: string;
  isExpanded: boolean;
  keepMounted: boolean;
  size: 'default' | 'condensed';
};

/** @internal */
export const AccordionSectionContext: Context<AccordionSectionContextProps> =
  createContext<AccordionSectionContextProps>({
    labelId: '',
    triggerId: '',
    contentId: '',
    isExpanded: false,
    keepMounted: false,
    size: 'default',
  });
